import i18next from 'i18next';

i18next.addResources('es_CL', 'CategoryItem', {
  seeOptions: 'Ver opciones'
});
